import { Component } from '@angular/core';

@Component({
  selector: 'ets-sso-signout',
  templateUrl: './sso-signout.component.html',
  styleUrls: ['./sso-signout.component.scss'],
})
export class SsoSignoutComponent {
  constructor() {}
}
